export default "__VITE_ASSET__0041eb87__"